import { render } from "./SelectDepartment.vue?vue&type=template&id=241b2532"
import script from "./SelectDepartment.vue?vue&type=script&lang=js"
export * from "./SelectDepartment.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/42/uchowanca/v2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__